<template>
    <div class="obs-modal-container">
        <div class="modal-form-container">
            <div class="title-box">
                <h2>{{ getString('alguma_observacao') }}</h2>
            </div>

            <div class="image-container">
                <img v-if="obsModalProd.subItemProductImage" :src="obsModalProd.subItemProductImage" alt="">
                <img v-else :src="noImageSrc">
            </div>

            <div class="name-container" v-if="obsModalProd.subItemName">
                <h2 v-text="getProductLanguage(obsModalProd, 'subItemName')"></h2>
            </div>

            <div class="details-container" v-if="obsModalProd.subItemDescription">
                <p v-text="'Descrição: ' + getProductLanguage(obsModalProd, 'subItemDescription')"></p>
            </div>

            <div class="observations-container" id="observations-container">
                <div class="observations-group-container" v-for="(obsGroup, key) in obsModalProd.subItemObservationsChoice" :key="key">
                    <span class="grupo-op-name">
                        <span v-text="getProductLanguage(obsGroup, 'subItemObsGroupName')"></span>
                        <span v-text="`${selectedObs.length || 0} / ${obsModalProd.subItemObservationsChoice[key].maxQuantity || (obsGroup.subItemObservations || []).length}`"></span>
                    </span>
                    <div class="obs-item-container">
                        <div class="item-obs" v-for="(obs, key2) in obsGroup.subItemObservations" :key="key2">
                            <div class="container-input" v-if="(obsModalProd.subItemObservationsChoice[key].maxQuantity !== 1)">
                                <input class="styled-input" :id="'child-item-obs' + key2 + obs.subItemObsCode" type="checkbox" :value="obs" v-model="selectedObs" @change="validateObs(obs, $event)" >
                                <span class="checkmark"></span>
                            </div>
                            <div class="container-input" v-else>
                                <input class="styled-input" :id="'child-item-obs' + key2 + obs.subItemObsCode" type="radio" :value="obs" v-model="selectedObs" @change="validateObs(obs, $event)" >
                                <span class="checkmark radio"></span>
                            </div>
                            <label :for="'child-item-obs' + key2 + obs.subItemObsCode" >
                                <span v-text="getProductLanguage(obs, 'subItemObsName')"></span>
                                <span v-if="obs.price" v-text="` + ${formatMoney(obs.price)}`"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <!-- Observação Digitada -->
                <div class="observations-group-container" v-if="exibeObsDigitada">
                    <span class="grupo-op-name">
                        <span>{{ getString('observacao_livre') }}</span>
                    </span>
                    <!-- <textarea v-model="typedObs" class="typed-obs-text" id="typed-obs" rows="5" maxlength="25" @focus="show" ></textarea> -->
                    <div id="typed-obs-modal" ref="typedObsModalDiv" class="div-input-android" @click="editObs"></div>
                </div>
                <div id="keyboard-filler" v-if="editingObs"></div>
            </div>
        </div>

        <div class="prod-item-footer">
            <DefaultButton :text="getString('sem_observacao')" outlined="true" @defaultBtnClick="modalCancel"></DefaultButton>
            <DefaultButton :text="getString('confirmar')" @defaultBtnClick="modalConfirm"></DefaultButton>
        </div>

        <div class="keyboard-overlay" v-if="editingObs" @click="closeKeyboard"></div>
        <!-- <AndroidKeyboard id="android-keyboard" v-if="editingObs"
            :inputElement="inputElement"
            :layout="layout">
        </AndroidKeyboard> -->
        <!-- <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input" /> -->
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/buttons/DefaultButton'
import LocaleController from '@/assets/controllers/LocaleController'
// import keyboardLayout from '@/assets/libs/keyboardLayout'
// import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'

export default {
  name: 'ObservationsModalGom',
  components: {
    DefaultButton
    // AndroidKeyboard
  },
  data () {
    return {
      inputElement: null,
      layout: '',
      editingObs: false,
      selectedObs: [],
      noImageSrc: null,
      exibeObsDigitada: Util.getLocalConfigs('permiteObsDigitada'),
      typedObs: '',
      obsModalProdLocal: JSON.parse(JSON.stringify(this.obsModalProd)),
      junk: require('../../../static/icons/junk-icon.png')
    }
  },
  props: ['obsModalProd'],
  mounted () {
    // console.log(this.obsModalProd)
    this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk
    this.obsModalProd.subItemObservationsChoice && this.obsModalProd.subItemObservationsChoice.forEach(obsGroup => {
      (obsGroup.subItemObservations || []).forEach(obs => {
        obs.subItemObsGroupCode = obsGroup.subItemObsGroupCode
      })
    })
  },
  methods: {
    getString: function (key) {
      return LocaleController.getString(key)
    },
    accept: function (text) {
      this.hide()
    },
    show: function (e) {
      if (!Util.isAndroidMode()) {
        this.input = e.target

        if (!this.visible) {
          this.visible = true
        }

        const obsContainer = document.getElementById('observations-container')
        setTimeout(() => {
          obsContainer.scrollTo(0, obsContainer.scrollHeight)
        }, 100)
      }
    },
    hide: function () {
      this.visible = false
    },
    getImagesURL: function () {
      return Util.getLocalConfigs('urlIMGOdhenInterface')
    },
    modalCancel: function () {
      this.$emit('obsModalClose', this.obsModalProd)
    },
    modalConfirm: function () {
      const updatedObsModalProd = {
        ...this.obsModalProd, // Copia todas as propriedades da prop
        observations: (this.selectedObs && Array.isArray(this.selectedObs)) ? this.selectedObs : [this.selectedObs],
        typedObs: this.typedObs.trim()
      }

      // Emite o objeto atualizado para o componente pai
      this.$emit('obsModalClose', updatedObsModalProd)
    },
    formatMoney: function (price) {
      return Util.formatMoney(price)
    },
    validateObs: function (obs, clickEvent) {
      const obsGroup = this.obsModalProd.subItemObservationsChoice.find(element => element.subItemObsGroupCode === obs.subItemObsGroupCode)
      const maxObservations = obsGroup.maxQuantity
      let groupSelectedObs = []
      if (this.selectedObs && (maxObservations !== 1) && this.selectedObs.length) {
        groupSelectedObs = this.selectedObs.filter(element => element.subItemObsGroupCode === obs.subItemObsGroupCode)
      } else if (this.selectedObs && maxObservations === 1) {
        groupSelectedObs.push(this.selectedObs)
      }

      const groupObsNumber = (groupSelectedObs && groupSelectedObs.length) || 0

      if ((maxObservations != null && maxObservations !== 0) && groupObsNumber > maxObservations && clickEvent.srcElement.checked) {
        this.selectedObs.pop()
        clickEvent.srcElement.checked = false
      }
    },
    getProductLanguage: function (product, index) {
      return LocaleController.getIndexLanguages(product, index)
    },
    editObs: function () {
      this.inputElement = this.$refs.typedObsModalDiv
      this.editingObs = true

      const obsContainer = document.getElementById('observations-container')
      setTimeout(() => {
        obsContainer.scrollTo(0, obsContainer.scrollHeight)
      }, 100)
    },
    closeKeyboard: function () {
      this.editingObs = false
      this.typedObs = this.$refs.typedObsModalDiv.innerText
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../../assets/common.less");

    .obs-modal-container {
        position: fixed;
        left: -20px;
        right: -20px;
        bottom: 0;
        top: 20px;
        background: #fff;
        border-radius: 8px;
        z-index: 11;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        height: calc(100% - 125px);
        margin: auto 50px;

        .modal-form-container {
            position: relative;
            overflow: hidden auto;
            display: flex;
            flex-direction: column;

            .title-box {
                background-color: var(--primaryColor);
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 8px 8px 0px 0px;
                margin-bottom: 0;

                h2 {
                    color: #fff;
                    margin: auto;
                    font-size: 22px;
                }
            }

            .image-container {
                padding: 15px;

                img {
                    height: 100px;
                    object-fit: scale-down;
                    margin: auto;
                    display: block;
                }
            }

            .name-container {
                margin: auto;
                display: block;
                margin-bottom: 5px;
                margin-left: 20px;
                margin-right: 20px;
                color: var(--primaryColor);
                padding: 0 10px;
                text-align: center;

                h2 {
                    font-size: 18px;
                }
            }

            .details-container {
                padding: 15px 30px 15px 30px;
                display: flex;
                align-content: center;
                align-items: center;
                p {
                    padding: 0;
                }
            }

            .observations-container {
                overflow: hidden scroll;
                position: relative;
                flex-grow: 1;
                padding: 0 15px;
                height: calc(100vh - 435px);
                width: calc(100% - 30px);

                .observations-group-container {
                    margin-bottom: 25px;
                    .grupo-op-name {
                        position: relative;
                        display: flex;
                        padding: 5px 5px;
                        color: white;
                        background: var(--primaryColor);
                        margin-bottom: 5px;
                        justify-content: space-between;
                        border-radius: 5px;
                        span {
                            display: inline-block;
                            vertical-align: middle;
                            font-weight: bold;
                            font-size: 16px;
                        }
                    }
                    .obs-item-container{
                        position: relative;
                        display: grid;
                        grid-template-columns: calc(50% - 7.5px) calc(50% - 7.5px);
                        grid-column-gap: 15px;
                        padding-bottom: 25px;
                        .item-obs {
                            display: grid;
                            margin-top: 15px;
                            grid-column-gap: 0;
                            grid-template-columns: auto auto;
                            border: solid 2px rgba(0, 0, 0, 0.3);
                            border-radius: 5px;
                            padding: 10px;
                            word-break: break-word;
                            .container-input {
                                padding: 5px;
                            }
                            label {
                                 margin: auto 3px;
                                  font-size: 14px;
                            }
                        }
                    }
                    .typed-obs-text {
                        font-size: 32px;
                        font-family: 'Poppins', sans-serif;
                        width: 100%;
                        resize: none;
                        border: solid 2px rgba(0, 0, 0, 0.3);
                    }
                }

                #keyboard-filler {
                    height: 150px;
                }
            }
        }

        .prod-item-footer {
            position: relative;
            display: grid;
            grid-template-columns: calc(50% - 10px) calc(50% - 10px);
            grid-column-gap: 20px;
            padding: 0 20px;
            background: rgba(0, 0, 0, 0.1);
            height: 70px;
            border-radius: 0 0 8px 8px;

            button.button-default {
                position: relative;
                display: block;
                margin: auto;
                min-width: inherit;
                background: var(--primaryColor);
                color: white;
                border: none;
                border-radius: 8px;
                height: 50px;
                width: calc(100% - 10px);
            }
        }
    }
</style>

<style lang="less">
.obs-modal-container .prod-item-footer button.button-default {
  span {
    font-size: 16px;
    margin: auto;
  }
}
</style>
